import {
  COMPANY_SIZES,
  LicenseHolderState,
  LicenseStylesState,
  LicenseTypesState,
  LicenseUsageState,
} from "../models/Licensing";
import {
  saveFontStyles,
  saveLicenseHolder,
  saveLicenseUsage,
  savePhysicalProducts,
  savePlatformSelections,
} from "./CartStorage";

import { CartDetails } from "./CartDetails";
import { FONT_SETTINGS } from "../../fonts";
import { FoundryCart } from "../foundry_client/models/FoundryCart";
import { Product } from "../models/Products";

/**
 * Transform cart details to and from contentful.
 */
export default class ContentfulCartTransformer {
  static toJson(cartDetails: CartDetails) {
    const metadata = {
      families: cartDetails.families,
      isEducationalLicense: cartDetails.licenseUsage?.isEducationalLicense,
      isOnBehalfOfSomeoneElse:
        cartDetails.licenseUsage?.isOnBehalfOfSomeoneElse,
      licenseHolderName: cartDetails.licenseHolder?.name,
      licenseHolderEmail: cartDetails.licenseHolder?.emailAddress,
      licenseHolderCompanySize: cartDetails.licenseHolder?.companySize,
      licenseHolderAddOns: cartDetails.licenseHolder?.addOns,
      physicalProducts: cartDetails.physicalProducts,
    };

    return metadata;
  }

  static loadFrom(cart: FoundryCart): CartDetails {
    const details = new CartDetails({
      isEducationalLicense: cart.educationalLicense,
      isOnBehalfOfSomeoneElse: cart.onBehalfOfSomeoneElse,
    });

    details.families = cart.families || {};
    details.licenseHolder = {
      name: cart.licenseHolderName,
      emailAddress: cart.licenseHolderEmail,
      companySize: cart.licenseHolderCompanySize,
      addOns: cart.licenseHolderAddOns,
    };

    details.physicalProducts = cart.physicalProducts || [];
    return details;
  }

  static saveCartFrom(details: CartDetails) {
    if (!details.licenseHolder) {
      return;
    }

    const usage: LicenseUsageState | null = details.licenseUsage
      ? {
          license_usage_on_behalf_of:
            details.licenseUsage.isOnBehalfOfSomeoneElse,
          license_usage_for_education:
            details.licenseUsage.isEducationalLicense,
        }
      : null;

    const holder: LicenseHolderState | null = details.licenseHolder
      ? {
          license_holder_name: details.licenseHolder.name,
          license_holder_company_size: Object.fromEntries(
            COMPANY_SIZES.map((size) => [
              size,
              details.licenseHolder?.companySize == size,
            ])
          ),
          license_holder_email_address: details.licenseHolder.emailAddress,
          addons_share_with_third_party:
            details.licenseHolder.addOns.shareWithThirdParty,
        }
      : null;

    Object.entries(details.families).forEach(([familyName, familyDetails]) => {
      const platforms: LicenseTypesState = {
        desktop: familyDetails.platforms.includes("desktop"),
        web: familyDetails.platforms.includes("web"),
        app: familyDetails.platforms.includes("app"),
        logo: familyDetails.platforms.includes("logo"),
      };

      savePlatformSelections(familyName, platforms);

      const bundlesOrder = FONT_SETTINGS[familyName].stylePurchaseBundles.map(
        (bundle) => bundle.id
      );

      const stylesOrder = FONT_SETTINGS[familyName].styleGroups
        .map((group) => {
          return group.fontStyles.map((style) => style.id);
        })
        .flat();

      const stylesState: LicenseStylesState = {
        bundles: Object.fromEntries(
          bundlesOrder.map((bundleId) => [
            bundleId,
            familyDetails.items.some((item: Product) => item.id === bundleId),
          ])
        ),
        styles: Object.fromEntries(
          stylesOrder.map((styleId) => [
            styleId,
            familyDetails.items.some((item: Product) => item.id === styleId),
          ])
        ),
      };

      console.log("SAVING STYLES");
      console.log({ stylesState });

      saveFontStyles(familyName, stylesState);
    });

    // Object.entries(FONT_SETTINGS).forEach(([familyName, familyDetails]) => {
    //   const selectedLicenseTypes = getData("fontLicenseTypes", familyName);
    //   const selectedStyles = getData("fontAddStyles", familyName);

    //   if (!selectedLicenseTypes || !selectedStyles) {
    //     return;
    //   }
    // });

    // const platforms: LicenseTypesState = Object.fromEntries(details.)

    if (usage) {
      saveLicenseUsage(usage);
    }
    if (holder) {
      saveLicenseHolder(holder);
    }

    savePhysicalProducts(details.physicalProducts);
  }
}
